import 'dotenv/config'
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './assets/css/jobpage.css';
import './formStyles.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from "react-router-dom";

//ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
/* serviceWorker.register();

window.UpwardRegApp = {
    App: App,
    React: React,
    ReactDOM: ReactDOM
} */

ReactDOM.render(
	<BrowserRouter>
		<App />
	</BrowserRouter>, 
	document.getElementById("root")
);
